export const CODE = 'CODE';
export const REDIRECT_STATE = 'REDIRECT_STATE';
